import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ThreeDimensionalSVG = function ThreeDimensionalSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M3 9.5v11.7a2 2 0 00.9 1.7L15 30.2V16.4zM28 7.8L17 1.4a2.3 2.3 0 00-2 0L4 7.8l12 6.9zM17 16.4v13.8l11.1-7.3a2 2 0 00.9-1.7V9.5z"
  }));
};
ThreeDimensionalSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ThreeDimensionalSVG);